<div class="background"
  responsiveBackgroundImage="/assets/operation-hope/support-c2a-bg.png"
  ></div>

<div class="foreground">
  <div class="c2a">
    We can only create hope with your support.
  </div>

  <a mat-raised-button color="primary" routerLink="/join/membership">
    Support this Community
  </a>
</div>